import { CardTypes, IPaymentMethod } from '../../types';
import { IGetPrepaidReloadPaymentMethodId } from '../types';

import { getValidPaymentMethodId } from './getValidPaymentMethodId';
import { getPreferredWalletOrder } from './utils';

const getValidDefaultReloadMethod = (accounts: IPaymentMethod[], usersPaymentMethodId: string) => {
  const notGiftCardPaymentMethod = accounts.find(
    paymentMethod => paymentMethod.accountIdentifier !== usersPaymentMethodId
  );

  return notGiftCardPaymentMethod?.accountIdentifier;
};

/**
 * Prepaid payment method can be a CC, Apple or Google Pay (i.e. anything but a prepaid card).
 *
 * When both wallets are available the platform-preferred one wins:
 * iOS -> Apple Pay, Android -> Google Pay, web -> Apple Pay (default).
 */
export const getPrepaidReloadPaymentMethodId = ({
  paymentMethodHasBeenInit,
  accounts,
  usersPaymentMethodId,
  canUseApplePay,
  canUseGooglePay,
  applePayCardDetails,
  googlePayCardDetails,
  isUsersPaymentMethodGiftCard,
}: IGetPrepaidReloadPaymentMethodId) => {
  const prepaidReloadAccounts = accounts;
  let userPrepaidReloadPaymentMethodId = usersPaymentMethodId;
  if (isUsersPaymentMethodGiftCard || !userPrepaidReloadPaymentMethodId) {
    userPrepaidReloadPaymentMethodId =
      getValidDefaultReloadMethod(accounts, usersPaymentMethodId) ?? '';
  }

  const { first, second } = getPreferredWalletOrder();

  const walletMap: Record<string, { canUse: boolean; details: IPaymentMethod }> = {
    [CardTypes.APPLE_PAY]: { canUse: canUseApplePay, details: applePayCardDetails },
    [CardTypes.GOOGLE_PAY]: { canUse: canUseGooglePay, details: googlePayCardDetails },
  };

  // Process the less-preferred wallet first so the preferred one overwrites the selection
  for (const wallet of [second, first]) {
    const { canUse, details } = walletMap[wallet];
    if (canUse) {
      prepaidReloadAccounts.unshift(details);
      if (!paymentMethodHasBeenInit) {
        userPrepaidReloadPaymentMethodId = wallet;
      }
    }
  }
  // Return a valid prepaid payment method (cannot be a prepaid card)
  return getValidPaymentMethodId({
    canUseApplePay,
    canUseGooglePay,
    paymentMethodId: userPrepaidReloadPaymentMethodId,
    paymentMethods: prepaidReloadAccounts.filter(method => !!method.credit),
    returnFirstValid: true,
  });
};
